// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfISOWeekYear as fn } from "../endOfISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfISOWeekYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfISOWeekYear;
